import { TimeDimension, TimeDimensionGranularity } from '@cubejs-client/core';
import { DateRange } from '@mui/x-date-pickers-pro';
import { format } from 'date-fns';

import { calculateDateOffset, DateOffsetType } from '~/util/date/calculateDateOffset';

export const convertDateRangeToTimeDimension = (
  dimension: string,
  value: DateRange<Date>,
  granularity?: TimeDimensionGranularity,
): TimeDimension[] => {
  if (!value[0] || !value[1]) {
    return [];
  }
  return [
    {
      dimension,
      granularity,
      dateRange: [format(value[0], 'yyyy-MM-dd'), format(value[1], 'yyyy-MM-dd')],
    },
  ];
};

export const lastYearDateRange: readonly [string, string] = [
  format(calculateDateOffset(new Date(), DateOffsetType.YEAR, -1), 'yyyy-MM-dd'),
  format(new Date(), 'yyyy-MM-dd'),
];
export const last6MonthsDateRange: readonly [string, string] = [
  format(calculateDateOffset(new Date(), DateOffsetType.MONTH, -6), 'yyyy-MM-dd'),
  format(new Date(), 'yyyy-MM-dd'),
];
export const previousYearDateRange: readonly [string, string] = [
  format(calculateDateOffset(new Date(), DateOffsetType.YEAR, -2), 'yyyy-MM-dd'),
  format(calculateDateOffset(new Date(), DateOffsetType.YEAR, -1), 'yyyy-MM-dd'),
];
export const lastYearToNext6MonthsDateRange: readonly [string, string] = [
  format(calculateDateOffset(new Date(), DateOffsetType.YEAR, -1), 'yyyy-MM-dd'),
  format(calculateDateOffset(new Date(), DateOffsetType.MONTH, +6), 'yyyy-MM-dd'),
];
